import * as colors from "../../assets/_base/colors"

const baseStyle = props => `
  font-family: Titillium Web;
  border: 1px solid ${colors.lightBlue};
  padding: 6px;
  font-size: 1.2em;
  border-radius: 3px;
  color: ${colors.darkBlue};
  width: 100%;

  :focus, :active {
    border: 2px solid ${colors.darkBlue};
    color: ${colors.darkBlue};
    border-radius: 5px;
    font-weight: 900;
    outline: none !important;
  }
  :disabled {
    border: 1px solid ${colors.lightCyan};
  }
  &:active{
    outline: none !important;
  }
`

export default baseStyle


// WEBPACK FOOTER //
// ./src/_components/Input/style.js